/** Where the home page opens. */
export enum DASHBOARD_VARIANTS {
    /** Follows the role: CSO / CMO on agent performance, everyone else on widgets. */
    ROLE_DEFAULT = "role-default",
    WIDGETS = "widgets",
    AGENT_PERFORMANCE = "agent-performance-dashboard",
}
